import { Injectable } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ExportPopoverComponent } from '../components/export-popover.component';
import { PopoverProps } from '../models';

@Injectable()
export class PopoverService {
	public constructor(private popoverController: PopoverController) {}

	public async presentPopover(event: PointerEvent, props: PopoverProps): Promise<any> {
		const popoverReference = await this.popoverController.create({
			component: ExportPopoverComponent,
			componentProps: props,
			cssClass: 'popover-menu',
			event,
			translucent: true,
			mode: 'md'
		});

		await popoverReference.present();
	}
}
